import {
  Box,
  Card,
  IconButton,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import DebouncedButton from "components/base/DebouncedButton";
import React from "react";
import Button from "components/base/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "@apollo/client";
import {
  CREATE_PRESCRIPTION,
  DELETE_PRESCRIPTION,
} from "graphql/PrescriptionQueries";
import { GET_CAREPLAN_TEMPLATE } from "graphql/TemplateQueries";

interface Props {
  templateId: string;
  index: number;
  isActive: boolean;
  prescriptionId: string;
  children: React.ReactNode;
}

const FlexStartDiv = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const PrescriptionSites = ({
  templateId,
  index,
  prescriptionId,
  isActive,
  children,
}: Props) => {
  const [deletePrescription] = useMutation(DELETE_PRESCRIPTION, {
    refetchQueries: [
      { query: GET_CAREPLAN_TEMPLATE, variables: { templateId } },
    ],
  });

  return (
    <>
      <Card sx={{ maxWidth: "960px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ padding: "8px 16px 0px 16px" }}
        >
          <Typography variant="h6">Prescription {index + 1}</Typography>
          <IconButton
            onClick={() => {
              deletePrescription({ variables: { prescriptionId } });
            }}
            disabled={!isActive}
          >
            <DeleteIcon color="error" />
          </IconButton>
        </Stack>
        <div>{children}</div>
      </Card>
    </>
  );
};

export default PrescriptionSites;
